module.exports = new __parcel__URL__("C2.6ae2e18f.mp3").toString();